export default async function activeProperty({ from, next }) {
  // check cookies and auth
  // const property = store.getters['properties/getProperty']
  const property = localStorage.getItem('property')
  const subscriptionStart = localStorage.getItem('subscriptionStart')
  const subscriptionEnd = localStorage.getItem('subscriptionEnd')
  if (
    property !== 'rejected' &&
    new Date(subscriptionStart) <= new Date() &&
    new Date(subscriptionEnd) >= new Date()
  ) {
    return next()
  } else {
    if (from.name != 'expired') {
      return next({
        name: 'expired'
      })
    } else {
      return next(new Error('EXPIRED'))
    }
  }
}
